module.exports = __webpack_public_path__ + "img/art4.f49f8a52.png";